import type { CSSProperties, ReactElement } from 'react';
import { EdgeLabelRenderer } from '@xyflow/react';
import { CmarkdownLabelText } from '../Cmarkdowntext/CmarkdownLabelText';
import { FontWeight } from '@/theme/typography';
import { EDGE_LABEL_BACKGROUND, TRANSITION_DURATION, } from './flowchart-constants';
import type { Point } from './flowchart-edge-geometry';
const EDGE_LABEL_BORDER = '1px solid rgba(255,255,255,0.08)';
const EDGE_LABEL_BORDER_RADIUS = 9;
const EDGE_LABEL_PADDING = '2px 8px';
const EDGE_LABEL_SIZE = 11;
const EDGE_LABEL_WHITE_SPACE_NOWRAP = 'nowrap';
const EDGE_LABEL_PARAGRAPH_STYLE: CSSProperties = { marginBottom: 0 };
interface FlowchartEdgeLabelProps {
    color: string;
    label: string | null | undefined;
    labelOpacity: number;
    labelPosition: Point;
}
function buildEdgeLabelStyle(input: {
    labelOpacity: number;
    labelPosition: Point;
}): CSSProperties {
    return {
        position: 'absolute',
        transform: `translate(-50%, -50%) translate(${input.labelPosition.x}px, ${input.labelPosition.y}px)`,
        pointerEvents: 'none',
        backgroundColor: EDGE_LABEL_BACKGROUND,
        border: EDGE_LABEL_BORDER,
        borderRadius: EDGE_LABEL_BORDER_RADIUS,
        padding: EDGE_LABEL_PADDING,
        opacity: input.labelOpacity,
        transition: `opacity ${TRANSITION_DURATION} ease-out`,
    };
}
export function FlowchartEdgeLabel({ color, label, labelOpacity, labelPosition, }: FlowchartEdgeLabelProps): ReactElement | null {
    if (!label) {
        return null;
    }
    return (<EdgeLabelRenderer>
        <div style={buildEdgeLabelStyle({ labelOpacity, labelPosition })}>
          <CmarkdownLabelText dataElScope="Cmarkdownflowchart/FlowchartEdgeLabel" content={label} size={EDGE_LABEL_SIZE} weight={FontWeight.Medium} paragraphStyle={EDGE_LABEL_PARAGRAPH_STYLE} textStyle={{ color, whiteSpace: EDGE_LABEL_WHITE_SPACE_NOWRAP }}/>
        </div>
    </EdgeLabelRenderer>);
}
